import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

export default class ScrollToTop {

	constructor(el) {
		this.button = el;

		if(!this.button) {
			return;
		}

		this.button.addEventListener('click', (e) => {
			e.preventDefault();
			const target =  document.querySelector('body');

			gsap.to(window, {
				duration: 2,
				ease: 'power4.inOut',
				scrollTo: {
					y: target,
					offsetY:200
				}
			});

		});
	}
}
